import Moment from "moment";
import { createStatusAgent } from "../actions";

class ReconnectionHandler {
  isReconnecting = false;
  hasAtdsBeforeReconnection = false;
  atdsBeforeReconnection = [];

  startReconnection(getState = () => {}) {
    this.isReconnecting = true;
    const atdSimult = getState().atdsimult;
    this.hasAtdsBeforeReconnection =
      Array.isArray(atdSimult) && atdSimult.length > 0;
    this.atdsBeforeReconnection = atdSimult;
  }
  reconnectionFinished() {
    this.isReconnecting = false;
    this.hasAtdsBeforeReconnection = false;
    this.atdsBeforeReconnection = [];
  }

  setCorrectStatus(getState = () => {}, dispatch = () => {}) {
    try {
      const atdSimult = getState().atdsimult;
      const hasAtds = Array.isArray(atdSimult) && atdSimult.length > 0;
      if (!hasAtds && this.hasAtdsBeforeReconnection) {
        dispatch(
          createStatusAgent(
            "Encerrou",
            this.atdsBeforeReconnection[0].cliente,
            Moment().format("DD/MM/YYYY HH:mm:ss"),
          ),
        );
      }
    } catch (error) {
      console.log("setCorrectStatus Error: ", error);
    }
  }

  resetReconnectionHandler() {
    this.isReconnecting = false;
    this.hasAtdsBeforeReconnection = false;
    this.atdsBeforeReconnection = [];
  }
}

export const reconnectionHandler = new ReconnectionHandler();
